import CommonFieldName from "./CommonFieldName";

enum DealFieldName {
  NAME = CommonFieldName.NAME,
  SCORE = "score",
  CRM_LINK = CommonFieldName.CRM_LINK,
  AMOUNT = "amount",
  ADJUSTED_AMOUNT = "adjustedAmount",
  SOURCE = CommonFieldName.SOURCE,
  CLOSING_DATE = "closingDate",
  FILES = CommonFieldName.FILES,
  GROUPS = CommonFieldName.GROUPS,
  DAYS_LEFT_IN_FREQUENCY = CommonFieldName.DAYS_LEFT_IN_FREQUENCY,
  CREATOR = CommonFieldName.CREATOR,
  CREATOR_NAME = CommonFieldName.CREATOR_NAME,
  CREATOR_EMAIL = CommonFieldName.CREATOR_EMAIL,
  USER = CommonFieldName.USER,
  OWNER_NAME = CommonFieldName.OWNER_NAME,
  OWNER_EMAIL = CommonFieldName.OWNER_EMAIL,
  NEXT_ACTIVITY = CommonFieldName.NEXT_ACTIVITY,
  LAST_ACTIVITY_DATE = CommonFieldName.LAST_ACTIVITY_DATE,
  LAST_ACTIVITY_TYPE = CommonFieldName.LAST_ACTIVITY_TYPE,
  LAST_ACTIVITY_NAME = CommonFieldName.LAST_ACTIVITY_NAME,
  FREQUENCY_STATUS = CommonFieldName.FREQUENCY_STATUS,
  FREQUENCY_INTERVAL = CommonFieldName.FREQUENCY_INTERVAL,
  NO_CONTACT_IN = CommonFieldName.NO_CONTACT_IN,
  NOTES = CommonFieldName.NOTES,
  UNIQUE_ID = CommonFieldName.UNIQUE_ID,
  COMPANY = CommonFieldName.COMPANY,
  PERSON = CommonFieldName.PERSON,
  ADDRESS = "geoAddress.address",
  CITY = "geoAddress.city",
  REGION = "geoAddress.region",
  COUNTRY = "geoAddress.countryCode",
  POSTAL_CODE = "geoAddress.postalCode",
  GEOPOINT = CommonFieldName.GEOPOINT,
  DEAL_LOSS_REASON = "dealLossReason",
  DEAL_LOSS_COMMENT = "dealLossComment",
  ROTTING_DAYS_OUT = "rottingDaysOut",
  DAYS_IN_STAGE = "daysInStage",
  FUNNEL = "funnel",
  STAGE = "stage",
  STAGE_TYPE = "stage.type",
  CREATED_AT = CommonFieldName.CREATED_AT,
  UPDATED_AT = CommonFieldName.UPDATED_AT,
  TEAM = CommonFieldName.TEAM,
  TERRITORIES = CommonFieldName.TERRITORIES,
  VIEW_AS = CommonFieldName.VIEW_AS,
  COMPANY_IMPORT_ID = CommonFieldName.COMPANY_IMPORT_ID,
  COMPANY_EMAIL = "account.email",
  PERSON_IMPORT_ID = CommonFieldName.PERSON_IMPORT_ID,
  PERSON_EMAIL = "contact.email",
  QUICK_FILTER = "quickFilter",
}

export default DealFieldName;
